export const APPLICATIONS_LOAD_START = 'APPLICATIONS_LOAD_START';
export const APPLICATION_LOAD_START = 'APPLICATION_LOAD_START';
export const APPLICATIONS_LOAD_SUCCESS = 'APPLICATIONS_LOAD_SUCCESS';
export const APPLICATION_LOAD_SUCCESS = 'APPLICATION_LOAD_SUCCESS';
export const APPLICATIONS_LOAD_FAILURE = 'APPLICATIONS_LOAD_FAILURE';
export const PAGINATION_LOAD_SUCCESS = 'PAGINATION_LOAD_SUCCESS';

export const APPLICATIONS_UNREVIEWED_APPLICANTS_LOAD_START =
  'APPLICATIONS_UNREVIEWED_APPLICANTS_LOAD_START';

export const APPLICATIONS_SET_UNREVIEWED_APPLICANTS_COUNT =
  'APPLICATIONS_SET_UNREVIEWED_APPLICANTS_COUNT';

export const APPLICATIONS_SET_UNREVIEWED_APPLICANTS_LOAD_FAILURE =
  'APPLICATIONS_SET_UNREVIEWED_APPLICANTS_LOAD_FAILURE';

export const APPLICATIONS_SEARCH_CHANGE_FILTER = 'APPLICATIONS_SEARCH_CHANGE_FILTER';
export const APPLICATIONS_SEARCH_RESET_FILTER = 'APPLICATIONS_SEARCH_RESET_FILTER';
